import { isSettingsModal, ModalDescriptor } from '../modals'

export const isModalAnExclusiveUi = (descriptor: ModalDescriptor) => {
  if (!isSettingsModal(descriptor)) {
    return false
  }

  const { openSection, type } = descriptor

  if (['nlp_settings', 'step_settings'].includes(type)) {
    return true
  }

  if ('bot_settings' === type && openSection === 'json') {
    return true
  }

  return false
}
